export const HELP_CENTER = {
  HOME: 'help_center',
}
